<template>
  <v-card class="profile-menu">
    <!-- profile -->
    <v-list subheader>
      <v-list-item>
        <v-list-item-avatar
          class="profile-picture-col"
          width="32"
          height="32"
          min-width="0"
          max-width="32"
        >
          <profile-picture
            :size="32"
            :pic-url="
              userData.profileImage !== null ? userData.profileImage : ''
            "
          ></profile-picture>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="profile-username">
            {{ userData.fullName }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ userData.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <!-- menu list -->
    <v-list class="pt-2">
      <!-- language -->
      <v-list-item
        id="AppMenuProfileLanguage"
        class="d-flex justify-end align-center"
        rel="noopener"
      >
        <v-list-item-content class="pt-0 pb-0">
          <v-list-item-title>
            {{ $t("QoalaExternalDashboardProfile.profileLanguage") }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-icon class="ml-0 mt-0 mb-0 align-self-auto">
          <!-- language dropdown -->
          <v-menu :nudge-top="0" attach left offset-y min-width="150">
            <template #activator="{ on }">
              <v-btn
                id="AppMenuProfileLanguageToggle"
                color="#000"
                text
                ripple
                class="pl-1 pr-0"
                v-on="on"
              >
                {{ chosenLanguage }}
                <v-icon v-if="chosenLanguage !== ''">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-list>
                <!-- language item -->
                <v-list-item
                  v-for="(language, key) in languages"
                  :id="`AppMenuProfile${language.name}`"
                  :key="key"
                  rel="noopener"
                  @click.prevent="chooseLanguage(language)"
                >
                  <v-list-item-content
                    class="pt-0 pb-0"
                    :class="language.isSelected ? 'selected' : ''"
                  >
                    {{ language.name }}
                  </v-list-item-content>
                  <v-list-item-icon v-if="language.isSelected">
                    <v-icon>{{ mdiCheck }}</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-list-item-icon>
      </v-list-item>

      <!-- other(s) than language -->
      <v-list-item
        v-for="(item, index) in itemsMenu"
        :key="index"
        :to="!item.href ? { name: item.name } : null"
        :href="item.href"
        :disabled="item.disabled"
        :target="item.target"
        ripple="ripple"
        rel="noopener"
        @click.prevent="item.click"
      >
        <v-list-item-content class="pt-0 pb-0">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Log out -->
      <v-list-item
        id="AppMenuProfileLanguage"
        class="d-flex justify-end mt-8 logout action-red"
        ripple="ripple"
        rel="noopener"
        @click="$emit('toggle-modal-logout-desktop')"
      >
        <v-list-item-icon class="mr-0 mt-0 mb-0 align-self-auto">
          <v-icon class="pr-2">{{ mdiLogoutVariant }}</v-icon>
          {{ $t("QoalaExternalDashboardProfile.profileSignOut") }}
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mdiChevronRight, mdiLogoutVariant, mdiCheck } from "@mdi/js";
import Cookies from "js-cookie";
import { assign, filter, findIndex, forEach } from "lodash-es";

import ProfilePicture from "@/components/shared/ProfilePicture";

export default {
  name: "AppMenuProfile",

  components: {
    ProfilePicture,
  },

  props: {
    itemsLanguage: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      mdiChevronRight,
      mdiLogoutVariant,
      mdiCheck,
      languages: this.itemsLanguage,
    };
  },

  computed: {
    itemsMenu() {
      return [
        {
          title: this.$t("QoalaExternalDashboardProfile.profileMyProfile"),
          href: "#",
          click: () => {
            this.toProfilePage();
          },
        },
        // {
        //     title: 'Customise Navigation',
        //     href: '#',
        //     click: () => {
        //     }
        // }
      ];
    },

    userData() {
      // default format (fix 'undefined' fetch)
      let obj = {
        role: {},
      };

      if (this.$store.getters["auth/getUserData"] !== null) {
        obj = assign({}, this.$store.getters["auth/getUserData"]);
      }

      return obj;
    },

    chosenLanguage() {
      const filtered = filter(this.languages, (item) => item.isSelected)[0];
      let wording = "";

      if (typeof filtered !== "undefined") {
        wording = filtered.name;
      }

      return wording;
    },
  },

  async created() {
    // 'refresh' userData
    if (Cookies.get("r")) {
      try {
        await this.$store.dispatch("auth/authRefresh", {
          data: {
            refresh: Cookies.get("r"),
          },
        });
      } catch (error) {
        this.$store.dispatch("auth/authDestroy");
      }
    } else {
      // this.$router.push('/');
      this.$store.dispatch("auth/authDestroy");
    }

    // flag selected language only if local language is found
    const lang = this.$i18n.locale;
    const langIndex = findIndex(this.languages, (item) => item.value === lang);

    if (typeof this.languages[langIndex] !== "undefined") {
      this.languages[langIndex].isSelected = true;
    } else if (typeof this.languages[0] !== "undefined") {
      // if local language not found --> fallback to the first language in languages
      this.chooseLanguage(this.languages[0]);
    }
  },

  methods: {
    chooseLanguage(item) {
      // deselect all item
      forEach(this.languages, (lang) => {
        lang.isSelected = false;
      });

      // setLocale to $i18n plugin, *moment*, persist state
      this.$i18n.setLocale(item.value);
      this.$store.dispatch("appPersisted/setLocale", item.value);

      // flag selected
      item.isSelected = true;

      // change itemsLanguage prop
      this.$emit("language-changed", this.languages);
    },

    toProfilePage() {
      this.$router.push(this.localePath("/profile"));
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-username {
  font-weight: bold;
}

.selected {
  font-weight: bold;
  position: relative;
  padding-right: 18px;
}

// arrow in profile menu
::v-deep.v-card .v-list .v-list-item,
::v-deep.v-card
  .v-list
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  .v-icon__svg {
    color: var(--bg-secondary) !important;
    caret-color: var(--bg-secondary) !important;
  }

  // red logout
  &.logout {
    .v-list-item__icon {
      color: $red !important;
      font-weight: bold;
    }

    .v-icon__svg {
      color: $red !important;
      caret-color: var(--bg-secondary);
    }
  }

  .v-list-item__content {
    color: $textColor !important;
  }
  .v-list-item__icon {
    margin: 6px 0;
  }
}

.profile-picture-col {
  overflow: visible;

  ::v-deep.v-avatar {
    box-shadow: 0 0 6px 0 rgb(var(--shadow-rgb), 0.5);
  }
}
</style>
